import type { RouteObject } from "react-router-dom";

export const marketRateCalculationRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Market Rate Calculation" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { MarketRateCalculation } = await import(
            "./market-rate-calculation"
          );
          return { Component: MarketRateCalculation };
        },
      },
    ],
  },
];
